import isArray from 'lodash/isArray';

import { LOCATION_CHANGE } from 'connected-react-router';
import { CopiesListState } from './state';
import {
    COPIES_LIST_FAILURE,
    COPIES_LIST_REQUEST,
    COPIES_LIST_RESET,
    COPIES_LIST_SUCCESS,
    COPIES_LIST_USAGE_CONDITIONS_UPDATE,
    CopiesListAction
} from './types';

const initialState = {
    lists: {},
    loading: false
} as CopiesListState;

export function copiesListReducers(
    copiesLists: CopiesListState = initialState,
    action: CopiesListAction
): CopiesListState {
    switch (action.type) {
        case COPIES_LIST_REQUEST: {
            return { ...copiesLists, loading: true };
        }
        case COPIES_LIST_SUCCESS: {
            const response = action.payload;
            const newList = {};
            newList[response.productId] = response;
            const lists = { ...copiesLists.lists, ...newList };
            return { ...copiesLists, lists, loading: false };
        }
        case COPIES_LIST_USAGE_CONDITIONS_UPDATE: {
            const productIds = action.payload;
            const newCopiesLists = { ...copiesLists };
            if (isArray(productIds)) {
                for (const productId of productIds) {
                    delete (newCopiesLists.lists as any)[productId]; // FIXME Remove any type
                }
            }
            return newCopiesLists;
        }
        case COPIES_LIST_FAILURE: {
            return { ...copiesLists, error: action.error, loading: false };
        }
        case LOCATION_CHANGE: {
            return { ...initialState };
        }
        case COPIES_LIST_RESET: {
            return { ...initialState };
        }
        default: {
            return { ...copiesLists };
        }
    }
}
